import ufeApi from 'services/api/ufeApi';
// https://confluence.sephora.com/wiki/display/ILLUMINATE/Update+preferred+zip+code

function updatePreferredZipCode(args) {
    const url = '/gway/v2/users/profile/preferredZipCode';

    return ufeApi
        .makeRequest(url, {
            method: 'PUT',
            body: JSON.stringify(args)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default updatePreferredZipCode;
